import script from "./priceCol.vue?vue&type=script&setup=true&lang=js"
export * from "./priceCol.vue?vue&type=script&setup=true&lang=js"

import "./priceCol.vue?vue&type=style&index=0&id=250f9c60&lang=scss"

const __exports__ = script;

export default __exports__